export default {
  id: "dashboard",
  title: "Admin Dashboard & Notifications",
  section: "Daily Operations",
  order: 5,
  keywords: "dashboard notifications pending approvals compliance email authorization tracking stats badges toggle personal",
  body: `
## What it is

The Dashboard is the admin morning screen: today's numbers plus every queue
that needs a human — approvals, schedule requests, compliance, and the
AI-drafted authorization emails. Each card links to the page where you act.

Admins get an **Admin / Personal** toggle at the top. Personal shows the
same dashboard a caregiver sees (your own shifts, hours, training, mileage)
— handy for admins who also work shifts.

## The stat cards

- **Total Clients** / **Total Caregivers** — with this month's new clients
  and today's scheduled caregivers.
- **Today's Shifts** — with percent completed so far.
- **Pending Approvals** — clocked-out shifts nobody has approved, with an
  **overdue** count for anything sitting more than 48 hours. Clicking jumps
  to the Shifts page pre-filtered to exactly those shifts.

## The queues

- **Pending Work Schedule Requests** — caregiver requests to change their
  availability windows, with Review buttons (you cannot review your own
  request). Reviewing opens the caregiver's work-schedule tab.
- **Employee Compliance** — caregivers grouped into **Pending Review**
  (documents uploaded, awaiting your check), **Expired**, and **Expiring
  Soon**. Each name links to that caregiver's compliance tab.
- **Email Authorization Tracking** — when a VR client's authorization runs
  low, the system drafts an authorization-request email with AI. Each
  alert opens a modal where you read the draft and **Approve** (send),
  **Reject**, or **Regenerate** it. Nothing is ever emailed without an
  approval here. The whole widget can be hidden per-user with its
  Show/Hide toggle if someone else owns this queue.

The dashboard refreshes itself every few minutes, so leave it open.

## How notifications work

There is no bell icon. Pending counts appear **on the sidebar menu
labels**: "Dashboard (3)", "Messages (2)", "Time Off (1)".

- **Dashboard (N)** rolls up authorization alerts + shifts pending approval
  + compliance items + general notifications (for example mileage cap
  warnings). A nonzero badge means "open the dashboard and check the
  queues."
- **Messages (N)** — unread messages.
- **Time Off (N)** — pending requests you can review.

## Suggested morning routine

1. Open the Dashboard; scan Pending Approvals (especially the overdue
   count) and clear it via the Shifts page.
2. Review schedule-change requests and time off (sidebar badge).
3. Work the Email Authorization queue — approve or fix the drafts.
4. Glance at compliance Expiring Soon before it becomes Expired.
`,
};
